(function () {
  function colorChartUrl(raw, ticket, imageId) {
    var origin = 'https://preview.paintbynumbersking.com';
    if (!/^[A-Za-z0-9-]+$/.test(ticket || '') || !/^[1-9]\d*$/.test(imageId || '') || !Number.isSafeInteger(Number(imageId))) return '';
    var path = '/admin/order-files/' + ticket + '/' + imageId + '/color-chart';
    var expected = origin + path;
    // Cached handoffs predate this field; the staff route does not depend on an upload or customer token.
    if (raw == null || raw === '') return expected;
    if (typeof raw !== 'string') return '';
    try {
      var url = new URL(raw);
      return url.protocol === 'https:' && url.origin === origin && url.pathname === path &&
        !url.username && !url.password && !url.search && !url.hash && url.href === expected ? expected : '';
    } catch (_) { return ''; }
  }

  function getShopifyMoneyFormat(section) {
    if (window.Shopify && Shopify.money_format) return Shopify.money_format;
    return (section && section.getAttribute('data-money-format')) || '${{amount}}';
  }

  function getActiveCurrency(section) {
    if (window.Shopify && Shopify.currency && Shopify.currency.active) {
      return Shopify.currency.active;
    }
    return (section && section.getAttribute('data-shop-currency')) || 'EUR';
  }

  function parseJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      return null;
    }
  }

  function normalizeCountry(value) {
    var country = String(value || '').trim().toUpperCase();
    return /^[A-Z]{2}$/.test(country) ? country : '';
  }

  function cartUrl(section) {
    return (section && section.getAttribute('data-cart-url')) || '/cart';
  }

  function shopifyRoute(path) {
    var root = '/';
    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      root = Shopify.routes.root;
    }
    return String(root || '/').replace(/\/?$/, '/') + String(path || '').replace(/^\//, '');
  }

  function syncRequestedCountry(section, requestedCountry, setStatus) {
    requestedCountry = normalizeCountry(requestedCountry);
    if (!requestedCountry) return true;

    var currentCountry = normalizeCountry(
      (section && section.getAttribute('data-current-country')) ||
      (window.Shopify && Shopify.country) ||
      ''
    );
    if (currentCountry === requestedCountry) return true;

    var form = section ? section.querySelector('[data-preview-localization-form]') : null;
    var countryInput = form ? form.querySelector('[data-preview-country-input]') : null;
    if (!form || !countryInput) return true;

    var storageKey = 'pbnk-country-sync:' + requestedCountry + ':' + window.location.pathname + window.location.search;
    try {
      if (window.sessionStorage && sessionStorage.getItem(storageKey) === '1') {
        if (setStatus) setStatus('We could not switch prices automatically. Please refresh this page before ordering.', 'error');
        return false;
      }
      if (window.sessionStorage) sessionStorage.setItem(storageKey, '1');
    } catch (e) {}

    if (setStatus) setStatus('Updating prices for your country...', '');
    countryInput.value = requestedCountry;

    var returnToInput = form.querySelector('input[name="return_to"]');
    if (returnToInput) {
      returnToInput.value = window.location.pathname + window.location.search + window.location.hash;
    }

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
    return false;
  }

  function formatMoney(section, cents) {
    var moneyFormat = getShopifyMoneyFormat(section);
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    try {
      var lang = document.documentElement.getAttribute('lang') || 'en';
      return new Intl.NumberFormat(lang, {
        style: 'currency',
        currency: getActiveCurrency(section)
      }).format(Number(cents || 0) / 100);
    } catch (e) {
      return '€' + (Number(cents || 0) / 100).toFixed(2);
    }
  }

  function setActiveTiles(scope) {
    if (!scope) return;
    scope.querySelectorAll('[data-option-tile]').forEach(function (tile) {
      var input = tile.querySelector('input');
      tile.classList.toggle('is-active', !!(input && input.checked));
    });
  }

  function parseRecommendedSizeParts(value) {
    var raw = String(value || '').trim();
    if (!raw) return { inch: '', cm: '' };

    var inchMatch = raw.match(/(\d+\s*(?:x|×)\s*\d+\s*(?:in|inch|inches)|\d+"\s*x\s*\d+")/i);
    var cmMatch = raw.match(/(\d+\s*(?:x|×)\s*\d+\s*cm)/i);
    var compactCmMatch = raw.match(/\((\d+\s*(?:x|×)\s*\d+\s*cm)\)/i);

    return {
      inch: inchMatch ? inchMatch[1].replace(/\s+/g, ' ').trim() : '',
      cm: compactCmMatch ? compactCmMatch[1].replace(/\s+/g, ' ').trim() : (cmMatch ? cmMatch[1].replace(/\s+/g, ' ').trim() : '')
    };
  }

  function optionValues(variants, optionIndex) {
    var values = [];
    (variants || []).forEach(function (variant) {
      var value = variant && variant.options ? String(variant.options[optionIndex] || '') : '';
      if (value && values.indexOf(value) === -1) values.push(value);
    });
    return values;
  }

  function normalizeSizeKey(value) {
    var matches = String(value || '').toLowerCase().match(/\d+\s*(?:x|×)\s*\d+/g) || [];
    if (!matches.length) return '';
    var parts = matches[matches.length - 1].match(/(\d+)\s*(?:x|×)\s*(\d+)/);
    return parts ? (parts[1] + 'x' + parts[2]) : '';
  }

  function resolveSizeOption(variants, sizeKey, sizeLabel) {
    var values = optionValues(variants, 0);
    var targetKey = normalizeSizeKey(sizeKey) || normalizeSizeKey(sizeLabel);
    if (targetKey) {
      var sizeMatch = values.find(function (value) {
        return normalizeSizeKey(value) === targetKey;
      });
      if (sizeMatch) return sizeMatch;
    }
    return values.indexOf(sizeLabel) !== -1 ? sizeLabel : (values[0] || sizeLabel || sizeKey || '');
  }

  function resolveStoneOption(variants, value) {
    var values = optionValues(variants, 1);
    var normalized = String(value || '').trim().toLowerCase();
    var stoneType = normalized.indexOf('round') !== -1
      ? 'round'
      : (normalized.indexOf('square') !== -1 ? 'square' : normalized);
    var match = values.find(function (candidate) {
      return String(candidate).toLowerCase() === normalized ||
        (stoneType && String(candidate).toLowerCase().indexOf(stoneType) !== -1);
    });
    return match || values[0] || value || '';
  }

  function resolveFrameOption(variants, value) {
    var values = optionValues(variants, 2);
    var normalized = String(value || 'No Frame').trim().toLowerCase();
    var match = values.find(function (candidate) {
      return String(candidate).toLowerCase() === normalized;
    });
    if (!match && normalized.indexOf('no frame') !== -1) {
      match = values.find(function (candidate) {
        return String(candidate).toLowerCase().indexOf('no frame') !== -1;
      });
    }
    return match || values[0] || value || 'No Frame';
  }

  function findVariantByOptions(variants, size, stone, frame) {
    return (variants || []).find(function (variant) {
      return variant.options &&
        variant.options[0] === size &&
        variant.options[1] === stone &&
        variant.options[2] === frame;
    }) || null;
  }

  function markRecommendedSizeOption(sizeSelect, recommendedValue) {
    if (!sizeSelect || !recommendedValue) return;
    Array.prototype.forEach.call(sizeSelect.options || [], function (option) {
      var originalLabel = option.getAttribute('data-original-label') || option.textContent || '';
      option.setAttribute('data-original-label', originalLabel);
      option.removeAttribute('data-recommended-size');
      option.textContent = originalLabel;
      if (option.value !== recommendedValue) return;
      option.setAttribute('data-recommended-size', 'true');
      if (!/our advice|recommended/i.test(option.textContent || '')) {
        option.textContent += ' — Recommended for your preview ⭐';
      }
    });
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      normalizeSizeKey: normalizeSizeKey,
      resolveSizeOption: resolveSizeOption,
      resolveStoneOption: resolveStoneOption,
      resolveFrameOption: resolveFrameOption,
      findVariantByOptions: findVariantByOptions
    };
  }
  if (typeof document === 'undefined') return;

  document.querySelectorAll('[data-preview-order-page]').forEach(function (section) {
    var productData = parseJson(section.getAttribute('data-product-json-id'));
    var priceMap = parseJson(section.getAttribute('data-price-map-json-id')) || {};
    if (!productData || !productData.variants || !productData.variants.length) return;

    var params = new URLSearchParams(window.location.search);
    var previewUrl = params.get('preview_url') || '';
    var originalUrl = params.get('original_url') || '';
    var preservedPreviewUrl = params.get('preserved_preview_url') || previewUrl;
    var preservedOriginalUrl = params.get('preserved_original_url') || originalUrl;
    var ticketNumber = params.get('ticket') || '';
    var imageId = params.get('image_id') || '';
    // Use our namespaced storefront parameter; retain old copied links.
    var previewToken = params.get('pbnk_order_key') || params.get('preview_token') || '';
    var selectedImageIds = (params.get('selected_images') || '')
      .split(',')
      .map(function (value) { return String(value || '').trim(); })
      .filter(Boolean);
    var activeImageId = params.get('active_image_id') || imageId || (selectedImageIds[0] || '');
    var photoLabel = params.get('label') || '';
    var previewPageUrl = params.get('preview_page_url') || '';
    var recommendedSize = params.get('size') || '';
    var recommendedSizeLabel = resolveSizeOption(productData.variants, recommendedSize, params.get('size_label') || '');
    var recommendedStone = resolveStoneOption(productData.variants, params.get('stone_shape') || '');
    var recommendedFrame = resolveFrameOption(productData.variants, params.get('frame') || 'No Frame');
    var portalOrigin = params.get('portal_origin') || '';
    var requestedCountry = normalizeCountry(params.get('country') || params.get('customer_country_iso') || '');
    var preserveEnabled = !!(ticketNumber && imageId && portalOrigin);
    var isUS = section.getAttribute('data-is-us') === 'true';

    var mainImage = section.querySelector('[data-preview-main-image]');
    var enlargeButton = section.querySelector('[data-preview-enlarge]');
    var lightbox = section.querySelector('[data-preview-lightbox]');
    var lightboxImage = section.querySelector('[data-preview-lightbox-image]');
    var lightboxCaption = section.querySelector('[data-preview-lightbox-caption]');
    var lightboxClose = section.querySelector('[data-preview-lightbox-close]');
    var stageLabel = section.querySelector('[data-stage-label]');
    var stageThumbButtons = Array.prototype.slice.call(section.querySelectorAll('[data-stage-thumb]'));
    var thumbPreview = section.querySelector('[data-thumb-preview]');
    var thumbOriginal = section.querySelector('[data-thumb-original]');
    var originalInline = section.querySelector('[data-original-inline]');
    var originalInlineImage = section.querySelector('[data-original-inline-image]');
    var ticketValue = section.querySelector('[data-preview-ticket]');
    var photoValue = section.querySelector('[data-preview-photo]');
    var recommendationValue = section.querySelector('[data-preview-recommendation]');
    var statusBox = section.querySelector('[data-order-status]');
    var priceValues = Array.prototype.slice.call(section.querySelectorAll('[data-main-price]'));
    var comparePriceValue = section.querySelector('[data-compare-price]');
    var saveBadgeWrap = section.querySelector('[data-save-badge-wrap]');
    var saveBadge = section.querySelector('[data-save-badge]');
    var addButton = section.querySelector('[data-add-to-cart]');
    var addButtonText = section.querySelector('[data-add-to-cart-text]');
    var addButtonPrice = section.querySelector('[data-add-to-cart-price]');
    var sizeSelect = section.querySelector('[data-size-select]');
    var stoneWrap = section.querySelector('[data-stone-options]');
    var shapeWrap = section.querySelector('[data-shape-options]');
    var addButtonBaseLabel = (addButton && addButton.getAttribute('data-base-label')) || 'Add to cart';
    var bundleShell = section.querySelector('[data-bundle-shell]');
    var bundleSelector = section.querySelector('[data-bundle-selector]');
    var bundleSummary = section.querySelector('[data-bundle-summary]');
    var bundleStates = [];

    if (previewUrl && mainImage) mainImage.src = previewUrl;
    if (previewUrl && thumbPreview) thumbPreview.src = previewUrl;
    if (originalUrl && thumbOriginal) thumbOriginal.src = originalUrl;
    if (originalUrl && originalInline && originalInlineImage) {
      originalInline.hidden = false;
      originalInlineImage.src = originalUrl;
    }

    function createBundleState(item) {
      return {
        imageId: String(item.image_id || imageId || ''),
        colorChartUrl: colorChartUrl(item.color_chart_url, ticketNumber, String(item.image_id || imageId || '')),
        label: item.label || photoLabel || 'Photo',
        previewUrl: item.preview_url || previewUrl || '',
        originalUrl: item.original_url || originalUrl || '',
        preservedPreviewUrl: item.preserved_preview_url || preservedPreviewUrl || item.preview_url || previewUrl || '',
        preservedOriginalUrl: item.preserved_original_url || preservedOriginalUrl || item.original_url || originalUrl || '',
        size: resolveSizeOption(
          productData.variants,
          item.size || recommendedSize,
          item.selected_size || item.size_label || recommendedSizeLabel || current.size
        ),
        sizeKey: item.size || recommendedSize || '',
        stone: resolveStoneOption(productData.variants, item.selected_detail || item.stone_shape || recommendedStone || current.stone),
        shape: resolveFrameOption(productData.variants, item.selected_frame || item.selected_shape || item.frame || recommendedFrame || current.shape),
        selected: true
      };
    }

    function currentBundleState() {
      return bundleStates.find(function (entry) {
        return entry.imageId === String(activeImageId || imageId || '');
      }) || null;
    }

    function activeOrderEntry() {
      return currentBundleState() || {
        imageId: String(imageId || ''),
        colorChartUrl: colorChartUrl(params.get('color_chart_url'), ticketNumber, imageId),
        label: photoLabel || 'Photo',
        previewUrl: previewUrl || '',
        originalUrl: originalUrl || '',
        preservedPreviewUrl: preservedPreviewUrl || previewUrl || '',
        preservedOriginalUrl: preservedOriginalUrl || originalUrl || '',
        size: current.size,
        stone: current.stone,
        shape: current.shape
      };
    }

    function variantPriceForEntry(entry) {
      var variant = variantByOptions(entry.size, entry.stone, entry.shape) || productData.selected_or_first_available_variant || productData.variants[0];
      if (!variant) return 0;
      var priceEntry = priceMap[String(variant.id)] || null;
      return priceEntry ? Number(priceEntry.price || 0) : Number(variant.price || 0);
    }

    function refreshAddButton() {
      if (!addButton) return;
      var selectedEntries = bundleStates.length > 1
        ? bundleStates.filter(function (entry) { return entry.selected; })
        : [activeOrderEntry()];
      var total = selectedEntries.reduce(function (sum, entry) {
        return sum + variantPriceForEntry(entry);
      }, 0);
      var count = selectedEntries.length;

      if (addButtonText) {
        if (!count) {
          addButtonText.textContent = 'Select at least 1 photo';
        } else {
          addButtonText.textContent = count > 1 ? ('Add ' + count + ' photos to cart') : addButtonBaseLabel;
        }
      }
      if (addButtonPrice) {
        addButtonPrice.textContent = formatMoney(section, total);
      }
      addButton.disabled = !count;
      addButton.classList.toggle('is-disabled', !count);
      addButton.setAttribute('aria-disabled', !count ? 'true' : 'false');
    }

    function renderBundleSummary() {
      if (!bundleShell || !bundleSummary || bundleStates.length <= 1) return;
      var selectedItems = bundleStates.filter(function (entry) { return entry.selected; });
      if (!selectedItems.length) {
        bundleSummary.hidden = true;
        bundleSummary.innerHTML = '';
        return;
      }
      bundleSummary.hidden = false;
      bundleSummary.innerHTML = '';
      selectedItems.forEach(function (entry) {
        var row = document.createElement('div');
        row.className = 'pbn-bundle-summary-row';
        row.innerHTML = '<span>' + entry.label + '</span><span>' + [entry.size, entry.stone, entry.shape].filter(Boolean).join(' • ') + '</span>';
        bundleSummary.appendChild(row);
      });
    }

    function renderBundleSelector() {
      if (!bundleShell || !bundleSelector || bundleStates.length <= 1) return;
      bundleShell.classList.add('is-active');
      bundleSelector.innerHTML = '';
      bundleStates.forEach(function (entry) {
        var card = document.createElement('div');
        card.className = 'pbn-bundle-card' + (entry.imageId === String(activeImageId) ? ' is-active' : '') + (entry.selected ? '' : ' is-inactive');

        var previewButton = document.createElement('button');
        previewButton.type = 'button';
        previewButton.className = 'pbn-bundle-card-main';
        previewButton.setAttribute('aria-pressed', entry.imageId === String(activeImageId) ? 'true' : 'false');
        previewButton.addEventListener('click', function () {
          activeImageId = entry.imageId;
          applyBundleState(entry);
        });

        var thumbWrap = document.createElement('span');
        thumbWrap.className = 'pbn-bundle-thumb';
        var thumbImage = document.createElement('img');
        thumbImage.src = entry.originalUrl || entry.previewUrl || '';
        thumbImage.alt = entry.label;
        thumbWrap.appendChild(thumbImage);

        var meta = document.createElement('span');
        meta.className = 'pbn-bundle-meta';
        var label = document.createElement('span');
        label.className = 'pbn-bundle-label';
        label.textContent = entry.label;
        var options = document.createElement('span');
        options.className = 'pbn-bundle-options';
        options.textContent = [entry.size, entry.stone, entry.shape].filter(Boolean).join(' • ');
        meta.appendChild(label);
        meta.appendChild(options);

        previewButton.appendChild(thumbWrap);
        previewButton.appendChild(meta);

        var toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'pbn-bundle-toggle';
        toggle.textContent = entry.selected ? 'Remove' : 'Add back';
        toggle.addEventListener('click', function (event) {
          event.stopPropagation();
          entry.selected = !entry.selected;
          if (entry.selected) {
            activeImageId = entry.imageId;
          } else if (entry.imageId === String(activeImageId)) {
            var nextSelected = bundleStates.find(function (candidate) { return candidate.selected; });
            if (nextSelected) {
              activeImageId = nextSelected.imageId;
            }
          }

          var activeEntry = bundleStates.find(function (candidate) {
            return candidate.imageId === String(activeImageId);
          }) || entry;
          applyBundleState(activeEntry);
        });

        card.appendChild(previewButton);
        card.appendChild(toggle);
        bundleSelector.appendChild(card);
      });
      renderBundleSummary();
    }

    function syncOptionInputs(scope, name, value) {
      if (!scope) return;
      scope.querySelectorAll('input[name="' + name + '"]').forEach(function (input) {
        input.checked = input.value === value;
      });
      setActiveTiles(scope);
    }

    function applyBundleState(entry) {
      if (!entry) return;
      imageId = entry.imageId;
      photoLabel = entry.label;
      previewUrl = entry.previewUrl;
      originalUrl = entry.originalUrl;
      preservedPreviewUrl = entry.preservedPreviewUrl;
      preservedOriginalUrl = entry.preservedOriginalUrl;
      recommendedSize = entry.sizeKey || recommendedSize;
      recommendedSizeLabel = entry.size || recommendedSizeLabel;
      recommendedStone = entry.stone || recommendedStone;
      recommendedFrame = entry.shape || recommendedFrame;
      current.size = entry.size || current.size;
      current.stone = entry.stone || current.stone;
      current.shape = entry.shape || current.shape;

      if (mainImage && previewUrl) mainImage.src = previewUrl;
      if (thumbPreview && previewUrl) thumbPreview.src = previewUrl;
      if (thumbOriginal && originalUrl) thumbOriginal.src = originalUrl;
      if (originalInline && originalInlineImage) {
        originalInline.hidden = !originalUrl;
        if (originalUrl) originalInlineImage.src = originalUrl;
      }
      if (photoValue) photoValue.textContent = photoLabel || '—';
      if (ticketValue) ticketValue.textContent = ticketNumber || '—';
      if (sizeSelect && current.size) {
        sizeSelect.value = current.size;
        markRecommendedSizeOption(sizeSelect, current.size);
      }
      syncOptionInputs(stoneWrap, 'preview-order-stone-' + section.getAttribute('data-section-id'), current.stone);
      syncOptionInputs(shapeWrap, 'preview-order-shape-' + section.getAttribute('data-section-id'), current.shape);
      setStage('preview');
      syncVariantState();
      renderBundleSelector();
    }

    if (ticketValue) ticketValue.textContent = ticketNumber || '—';
    if (photoValue) photoValue.textContent = photoLabel || '—';

    var previousBodyOverflow = '';

    function openImageLightbox() {
      if (!mainImage || !lightbox || !lightboxImage) return;
      var imageUrl = mainImage.currentSrc || mainImage.src || '';
      if (!imageUrl) return;

      lightboxImage.src = imageUrl;
      lightboxImage.alt = mainImage.alt || 'Preview image';
      if (lightboxCaption) {
        lightboxCaption.textContent = mainImage.alt || '';
      }
      previousBodyOverflow = document.body.style.overflow || '';
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      if (lightboxClose) {
        lightboxClose.focus();
      }
    }

    function closeImageLightbox() {
      if (!lightbox || lightbox.hidden) return;
      lightbox.hidden = true;
      if (lightboxImage) {
        lightboxImage.src = '';
      }
      document.body.style.overflow = previousBodyOverflow;
    }

    if (enlargeButton) {
      enlargeButton.addEventListener('click', openImageLightbox);
    }
    if (lightboxClose) {
      lightboxClose.addEventListener('click', closeImageLightbox);
    }
    if (lightbox) {
      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox) {
          closeImageLightbox();
        }
      });
    }
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeImageLightbox();
      }
    });

    function setStage(mode) {
      if (!mainImage) return;
      var isOriginal = mode === 'original' && originalUrl;
      var imageUrl = isOriginal ? originalUrl : previewUrl;
      var activeButton = stageThumbButtons.find(function (button) {
        return button.getAttribute('data-stage-thumb') === (isOriginal ? 'original' : 'preview');
      });
      var labelNode = activeButton ? activeButton.querySelector('.pbn-preview-thumb-label') : null;
      var label = labelNode ? labelNode.textContent : (isOriginal ? 'Original photo' : 'Preview');
      mainImage.src = imageUrl || previewUrl || originalUrl || mainImage.src;
      mainImage.alt = label;
      if (stageLabel) stageLabel.textContent = label;
      stageThumbButtons.forEach(function (button) {
        button.classList.toggle('is-active', button.getAttribute('data-stage-thumb') === (isOriginal ? 'original' : 'preview'));
      });
    }

    stageThumbButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setStage(button.getAttribute('data-stage-thumb'));
      });
    });
    setStage('preview');

    var current = {
      size: recommendedSizeLabel,
      stone: recommendedStone,
      shape: recommendedFrame
    };

    bundleStates = [createBundleState({
      image_id: imageId,
      color_chart_url: params.get('color_chart_url'),
      label: photoLabel,
      preview_url: previewUrl,
      original_url: originalUrl,
      preserved_preview_url: preservedPreviewUrl,
      preserved_original_url: preservedOriginalUrl,
      size: recommendedSize,
      size_label: recommendedSizeLabel,
      stone_shape: recommendedStone,
      frame: recommendedFrame,
      selected_size: recommendedSizeLabel,
      selected_detail: recommendedStone,
      selected_frame: recommendedFrame
    })];

    if (sizeSelect && current.size) {
      sizeSelect.value = current.size;
      markRecommendedSizeOption(sizeSelect, current.size);
    }

    function variantByOptions(size, stone, shape) {
      return findVariantByOptions(productData.variants, size, stone, shape);
    }

    function syncVariantState() {
      var variant = variantByOptions(current.size, current.stone, current.shape) || productData.selected_or_first_available_variant || productData.variants[0];
      if (!variant) return null;

      current.size = variant.options[0];
      current.stone = variant.options[1];
      current.shape = variant.options[2];

      if (sizeSelect) sizeSelect.value = current.size;
      setActiveTiles(stoneWrap);
      setActiveTiles(shapeWrap);

      var priceEntry = priceMap[String(variant.id)] || null;
      var variantPrice = priceEntry ? Number(priceEntry.price || 0) : Number(variant.price || 0);
      var variantCompare = priceEntry ? Number(priceEntry.compare_at_price || 0) : Number(variant.compare_at_price || 0);
      var formattedMainPrice = formatMoney(section, variantPrice);

      priceValues.forEach(function (priceValue) {
        priceValue.setAttribute('data-cents', String(variantPrice));
        priceValue.textContent = formattedMainPrice;
      });

      if (comparePriceValue) {
        if (variantCompare > variantPrice) {
          comparePriceValue.hidden = false;
          comparePriceValue.setAttribute('data-cents', String(variantCompare));
          comparePriceValue.textContent = formatMoney(section, variantCompare);
        } else {
          comparePriceValue.hidden = true;
          comparePriceValue.textContent = '';
        }
      }

      if (saveBadge) {
        if (variantCompare > variantPrice) {
          var savePercent = Math.round(((variantCompare - variantPrice) / variantCompare) * 100);
          if (saveBadgeWrap) saveBadgeWrap.hidden = false;
          saveBadge.hidden = false;
          saveBadge.textContent = 'Save ' + String(savePercent) + '% Today';
        } else {
          if (saveBadgeWrap) saveBadgeWrap.hidden = true;
          saveBadge.hidden = true;
          saveBadge.textContent = '';
        }
      }

      if (addButton) refreshAddButton();

      if (recommendationValue) {
        var sizeSource = recommendedSizeLabel || recommendedSize || current.size || '';
        var sizeParts = parseRecommendedSizeParts(sizeSource);
        var recommendationParts = [];
        if (isUS) {
          if (sizeParts.inch) recommendationParts.push(sizeParts.inch);
          if (sizeParts.cm) recommendationParts.push(sizeParts.cm);
        } else {
          if (sizeParts.cm) recommendationParts.push(sizeParts.cm);
          if (sizeParts.inch) recommendationParts.push(sizeParts.inch);
        }
        if (!recommendationParts.length && sizeSource) recommendationParts.push(sizeSource);
        if (current.stone) recommendationParts.push(current.stone);
        if (current.shape) recommendationParts.push(current.shape);
        recommendationValue.textContent = recommendationParts.length ? recommendationParts.join(' / ') : '—';
      }

      var activeEntry = currentBundleState();
      if (activeEntry) {
        activeEntry.size = current.size;
        activeEntry.stone = current.stone;
        activeEntry.shape = current.shape;
        activeEntry.variantId = String(variant.id || '');
      }
      renderBundleSummary();
      refreshAddButton();

      return variant;
    }

    function wireOptionGroup(scope, key) {
      if (!scope) return;
      scope.addEventListener('change', function (event) {
        var input = event.target.closest('input[type="radio"]');
        if (!input) return;
        current[key] = input.value;
        setActiveTiles(scope);
        syncVariantState();
      });
      setActiveTiles(scope);
    }

    wireOptionGroup(stoneWrap, 'stone');
    wireOptionGroup(shapeWrap, 'shape');

    if (sizeSelect) {
      sizeSelect.addEventListener('change', function () {
        current.size = sizeSelect.value;
        syncVariantState();
      });
    }

    function setStatus(message, tone) {
      if (!statusBox) return;
      statusBox.textContent = message || '';
      statusBox.classList.remove('is-error', 'is-success');
      if (tone === 'error') statusBox.classList.add('is-error');
      if (tone === 'success') statusBox.classList.add('is-success');
    }

    async function preserveSelection(variant) {
      if (!preserveEnabled || !variant) return;
      var body = new URLSearchParams();
      body.set('variant_id', String(variant.id));
      body.set('size', current.size);
      body.set('detail', current.stone);
      body.set('frame', current.shape);
      await fetch(
        portalOrigin.replace(/\/$/, '') +
          '/api/ticket/' + encodeURIComponent(ticketNumber) +
          '/images/' + encodeURIComponent(imageId) +
          '/preserve-converted',
        { method: 'POST', body: body }
      );
    }

    async function loadBundleSelection() {
      if (!previewToken || selectedImageIds.length <= 1 || !portalOrigin) {
        return;
      }
      try {
        var response = await fetch(
          portalOrigin.replace(/\/$/, '') +
            '/api/preview/' + encodeURIComponent(previewToken) +
            '/shopify-bundle?image_ids=' + encodeURIComponent(selectedImageIds.join(','))
        );
        if (!response.ok) return;
        var payload = await response.json();
        if (!payload || !Array.isArray(payload.items) || payload.items.length <= 1) return;
        bundleStates = payload.items.map(function (item) {
          return createBundleState(item);
        });
        var matchingActive = bundleStates.find(function (entry) {
          return entry.imageId === String(activeImageId || '');
        }) || bundleStates[0];
        if (matchingActive) {
          activeImageId = matchingActive.imageId;
          applyBundleState(matchingActive);
        } else {
          renderBundleSelector();
        }
      } catch (error) {}
    }

    async function addMainProducts(items) {
      var res = await fetch(shopifyRoute('cart/add.js'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: items
        })
      });

      if (!res.ok) throw new Error('main_add_failed');
      return await res.json();
    }

    if (addButton) {
      addButton.addEventListener('click', async function () {
        if (addButton.disabled) {
          return;
        }
        if (!syncRequestedCountry(section, requestedCountry, setStatus)) {
          return;
        }
        var variant = syncVariantState();
        if (!variant) {
          setStatus('No matching variant was found for this combination.', 'error');
          return;
        }

        addButton.disabled = true;
        setStatus('Adding your order to cart...', '');

        try {
          var selectedEntries = bundleStates.length > 1
            ? bundleStates.filter(function (entry) { return entry.selected; })
            : [activeOrderEntry()];
          if (!selectedEntries.length) {
            setStatus('Please select at least one photo to continue.', 'error');
            addButton.disabled = false;
            return;
          }
          var items = selectedEntries.map(function (entry) {
            var entryVariant = variantByOptions(entry.size, entry.stone, entry.shape) || variant;
            return {
              id: Number(entryVariant.id),
              quantity: 1,
              properties: {
                '_pbnk_product_type': 'diamond',
                '_ticket_number': ticketNumber,
                '_image_id': entry.imageId,
                ...(entry.previewUrl && entry.originalUrl && entry.colorChartUrl ? { '_color_chart_url': entry.colorChartUrl } : {}),
                '_photo_label': entry.label,
                '_original_photo_url': entry.originalUrl,
                '_preview_photo_url': entry.previewUrl,
                '_legacy_original_photo_url': entry.originalUrl,
                '_legacy_preview_photo_url': entry.previewUrl,
                '_preserved_original_photo_url': entry.preservedOriginalUrl,
                '_preserved_preview_photo_url': entry.preservedPreviewUrl,
                '_chosen_size': entry.size,
                '_chosen_stone_type': entry.stone,
                '_chosen_stone_shape': entry.shape,
                '_customer_country': requestedCountry,
                '_variant_id': String(entryVariant.id)
              }
            };
          });
          await addMainProducts(items);
          try {
            for (var index = 0; index < selectedEntries.length; index += 1) {
              var preserveVariant = variantByOptions(selectedEntries[index].size, selectedEntries[index].stone, selectedEntries[index].shape) || variant;
              imageId = selectedEntries[index].imageId;
              current.size = selectedEntries[index].size;
              current.stone = selectedEntries[index].stone;
              current.shape = selectedEntries[index].shape;
              await preserveSelection(preserveVariant);
            }
          } catch (err) {}
          setStatus('Added to cart. Redirecting...', 'success');
          window.location.href = cartUrl(section);
        } catch (error) {
          setStatus('We could not add this order to the cart. Please try again.', 'error');
          addButton.disabled = false;
        }
      });
    }

    syncRequestedCountry(section, requestedCountry, setStatus);
    syncVariantState();
    loadBundleSelection();
  });
})();
